import request from '@/utils/http';
// 招标查询
export const tenderEnquiry = (params) => {
    return request({
        url: `/api-srm-web/bid/bidHead/bidHeadAudits`,
        method: 'post',
        data: params
    });
};
// 发起招标结果mip
export const bidRes = (bidNo, params) => {
    return request({
        url: `/api-srm-web/bid/bidConsequenceApprove/${bidNo}`,
        method: 'post',
        data: params
    });
};
// 发起拦标价mip
export const bidPrice = (params) => {
    return request({
        url: `/api-srm-web/bid/hurdlesIflowCreateDraft`,
        method: 'post',
        data: params
    });
};
// 发起招标方案mip
export const bidExamine = (params) => {
    return request({
        url: `/api-srm-web/bid/headIflowCreateDraft`,
        method: 'post',
        data: params
    });
};
// 查询mip流程
export const seachMip = (params) => {
    return request({
        url: `/api-iflow/queryOneInstance`,
        method: 'post',
        data: params
    }).then(res => res);
};